<span class="community-archive-btn">
  @if (item.current_user_permissions.archive) {
    <a
      [title]="getTitle()"
      href="#"
      (click)="toggleArchiveStatus(); $event.preventDefault()"
      class="archive-btn clickable"
      tabindex="0"
      [class.active]="item.state === 'archived'"
      >
      <i class="material-icons" aria-hidden="true">archive</i>
    </a>
  }
</span>